import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import EntitySidebar from 'components/EntitySidebar';

import { RegionSidebar_region$key } from '__generated__/RegionSidebar_region.graphql';

type Props = {
  region: RegionSidebar_region$key;
};

const RegionSidebar: FC<Props> = props => {
  const region = useFragment(
    graphql`
      fragment RegionSidebar_region on Region {
        ...EntitySidebar_entity
      }
    `,
    props.region
  );

  return <EntitySidebar entity={region} />;
};

export default RegionSidebar;
